import React, { Component } from "react";
import ProductHeader from "../../ProductDetails/ProductHeader";
import ActionButton from "../../ActionButton";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { saveAddress } from "../../../store/actions";
import ServiceType from "../../AreaSelect/ServiceType";
import DeliveryAreaLocation from "./DeliveryAreaLocation";
import AddressFormNew from "./AddressFormNew";
import Gift from "../Confirmation/Gift";
import Button from "@material-ui/core/Button";
import CardGiftcardOutlinedIcon from "@material-ui/icons/CardGiftcardOutlined";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { shouldShowNumberError } from "../../../Helpers/gift";

class index extends Component {
  state = {
    selectedAddressType: this.props.address?.selectedAddressType || 0,
    selectedDeliveryType: 0,
    block: "",
    street: null,
    paci: null,
    building: null,
    avenue: null,
    apartment: null,
    floor: null,
    additional: null,

    blockError: false,
    streetError: false,
    buildingError: false,
    apartmentError: false,
    floorError: false,
    additionalError: false,

    home_picture: null,
    giftDrawer: false,
    errorName:
      this.props.settings.enable_force_gift_name_number &&
      !this.props.promise.gift_name,
    errorNumber: shouldShowNumberError(this.props),
  };

  componentDidMount = () => {
    window.scrollTo(0, 0);
    const { settings, cart, auth, areas, branch_delivery_charges } = this.props;
    const delivery_enabled = settings.enable_delivery;
    let pickup_enabled = settings.enable_pickup;
    const { countries } = this.props;
    let selectedCountry = countries
      ? countries.find((country) => country.id == this.props.address?.country)
      : null;

    if (!selectedCountry) {
      selectedCountry = { name: "Kuwait" };
    }
    if (this.props.address) {
      const address = this.props.address;
      let selectedArea;
      if (settings.is_branch_based_ordering) {
        selectedArea = branch_delivery_charges.find(
          (bdc) => bdc.area_id === address?.area
        );
        if (selectedArea) {
          selectedArea = {
            name: selectedArea.area,
            province_name: selectedArea.province_en,
          };
        }
      } else {
        selectedArea = areas.find((a) => a.id === address?.area);
      }
      const alHamraSituationTing =
        selectedArea &&
        ([
          "arraya tower",
          "arraya center",
          "nbk tower",
          "assima mall",
          "mazaya tower",
          "international hospital",
        ].some((a) => selectedArea.name.toLowerCase().includes(a)) ||
          selectedArea.province_name === "Offices") &&
        address.selectedDeliveryType === 0;

      if (alHamraSituationTing) {
        this.setState({
          selectedDeliveryType: 0,
          selectedAddressType: 2,
          block: "-",
          street: "-",
          building: selectedArea.name.toLowerCase().includes("hamra tower")
            ? "AlHamra Tower"
            : selectedArea.name,
          apartment: address.apartment ? address.apartment : "",
          floor: address.floor ? address.floor : "",
          home_picture: address.home_picture ? address.home_picture : null,
        });
      } else {
        this.setState({
          selectedDeliveryType: 0,
          selectedAddressType: address.selectedAddressType,
          block: address.block
            ? address.block
            : selectedCountry.name === "Qatar"
            ? "-"
            : "",
          street: address.street ? address.street : "",
          building: address.building ? address.building : "",
          avenue: address.avenue ? address.avenue : "",
          apartment: address.apartment ? address.apartment : "",
          floor: address.floor ? address.floor : "",
          paci: address.paci ? address.paci : "",
          additional: address.additional ? address.additional : "",
          pickupArea: address.pickupArea,
          home_picture: address.home_picture ? address.home_picture : null,
        });
      }
      const checkGiftUnknownLocation =
        this.props.settings.enable_gifts &&
        this.props.settings.enable_gifts_staff &&
        this.props.promise.isGift &&
        this.props.settings.enable_unknown_gift_recipient_location &&
        this.props.promise.unknown_location &&
        this.props.address?.selectedDeliveryType === 0;
      if (checkGiftUnknownLocation) {
        this.handleAddressForUnknownLocation(true);
        if (
          this.state.block === "" ||
          this.state.street === "" ||
          this.state.building === ""
        ) {
          this.setState({
            block: "-",
            street: "-",
            building: "-",
          });
        }
      }
    }
  };

  handleNext = (e) => {
    const { countries, areas, address, settings, branch_delivery_charges } =
      this.props;
    let selectedCountry = countries
      ? countries.find((country) => country.id == this.props.address?.country)
      : null;
    if (!selectedCountry) {
      selectedCountry = { name: "Kuwait" };
    }
    const international = selectedCountry.name === "International";

    let street = this.state.street?.trim();
    if (selectedCountry.name === "Qatar" && !street) {
      street = "-";
      this.setState({ street: "-" });
    }

    // let selectedArea = areas.find((a) => a.id === address?.area);

    let selectedArea;
    if (settings.is_branch_based_ordering) {
      selectedArea = branch_delivery_charges.find(
        (bdc) => bdc.area_id === address?.area
      );
      if (selectedArea) {
        selectedArea = {
          name: selectedArea.area,
          province_name: selectedArea.province_en,
        };
      }
    } else {
      selectedArea = areas.find((a) => a.id === address?.area);
    }
    const useAddressLines =
      international || selectedArea?.province_name === "Kashtat";
    const alHamraSituationTing =
      selectedArea &&
      ([
        "arraya tower",
        "arraya center",
        "nbk tower",
        "assima mall",
        "mazaya tower",
        "international hospital",
      ].some((a) => selectedArea.name.toLowerCase().includes(a)) ||
        ["Offices", "Mosques"].includes(selectedArea.province_name)) &&
      address.selectedDeliveryType === 0;
    if (alHamraSituationTing) {
      this.setState({
        selectedDeliveryType: 0,
        selectedAddressType: 2,
        block: "-",
        street: "-",
        building: selectedArea.name.toLowerCase().includes("hamra tower")
          ? "AlHamra Tower"
          : selectedArea.name,
        paci: "",
        avenue: "",
        additional: "",
      });
    }

    if (this.props.settings.hide_block || selectedCountry.name === "UAE") {
      this.setState({
        block: "-",
      });
    }

    if (
      (!this.state.block &&
        !this.props.settings.hide_block &&
        selectedCountry.name !== "UAE") ||
      ((!this.state.building || !this.state.building.trim()) &&
        !useAddressLines) ||
      !this.state.block.trim() ||
      !street ||
      (!this.state.apartment?.trim() &&
        selectedCountry.name === "Qatar" &&
        (this.state.selectedAddressType === 1 ||
          this.state.selectedAddressType === 2)) ||
      (alHamraSituationTing &&
        (!this.state.floor.trim() || !this.state.apartment.trim())) ||
      (this.state.additional && this.state.additional.length > 254) ||
      (this.state.selectedAddressType === 2 &&
        !alHamraSituationTing &&
        (!this.state.apartment?.trim() || !this.state.floor.trim()))
    ) {
      let error = {};
      if (
        (!this.state.block || !this.state.block.trim()) &&
        !this.props.settings.hide_block &&
        selectedCountry.name !== "UAE"
      )
        error.blockError = true;
      if (!street) error.streetError = true;
      if (
        (!this.state.building || !this.state.building.trim()) &&
        !useAddressLines
      )
        error.buildingError = true;
      if (
        !this.state.apartment?.trim() &&
        ((selectedCountry.name === "Qatar" &&
          (this.state.selectedAddressType === 1 ||
            this.state.selectedAddressType === 2)) ||
          (this.state.selectedAddressType === 2 && !alHamraSituationTing))
      )
        error.apartmentError = true;
      if (
        (alHamraSituationTing && !this.state.floor.trim()) ||
        (!alHamraSituationTing &&
          this.state.selectedAddressType === 2 &&
          !this.state.floor.trim())
      ) {
        error.floorError = true;
      }
      if (alHamraSituationTing && !this.state.apartment.trim()) {
        error.apartmentError = true;
      }
      if (this.state.additional?.length > 254) {
        error.additionalError = true;
      }
      this.setState(error);
      window.scrollTo({ top: 1000, left: 0, behavior: "smooth" });
    } else {
      this.props.saveAddress({ ...this.state, street: street });
      this.props.history.push("/checkout/confirmation");
    }
  };

  handleChange = (e) => {
    if (
      e.target.name == "block" &&
      this.state.blockError &&
      e.target.value.trim()
    ) {
      this.setState({ blockError: false });
    }
    if (
      e.target.name == "street" &&
      this.state.streetError &&
      e.target.value.trim()
    )
      this.setState({ streetError: false });

    if (
      e.target.name == "building" &&
      this.state.buildingError &&
      e.target.value.trim()
    )
      this.setState({ buildingError: false });

    if (this.state.additionalError && this.state.additional?.length <= 254)
      this.setState({ additionalError: false });

    if (
      e.target.name === "apartment" &&
      this.state.apartmentError &&
      e.target.value.trim()
    )
      this.setState({ apartmentError: false });

    if (
      e.target.name === "floor" &&
      this.state.floorError &&
      e.target.value.trim()
    )
      this.setState({ floorError: false });

    this.setState({ [e.target.name]: e.target.value });
  };
  handleImageUpload = (image) => {
    this.setState({ home_picture: image });
  };

  renderActionButtonText = (international) => {
    const { language, settings, address, areas, promise } = this.props;
    let previousPath;
    if (this.props.history.location.state)
      previousPath = this.props.history.location.state?.prevPath;

    let selectedArea = areas.find((a) => a.id === address?.area);

    const alHamraSituationTing =
      selectedArea &&
      ([
        "arraya tower",
        "arraya center",
        "nbk tower",
        "assima mall",
        "mazaya tower",
        "international hospital",
      ].some((a) => selectedArea.name.toLowerCase().includes(a)) ||
        selectedArea.province_name === "Offices") &&
      address.selectedDeliveryType === 0;

    if (
      settings.force_geolocation &&
      !international &&
      !address.gpsConfirmed &&
      !promise.isGift &&
      !alHamraSituationTing
    ) {
      return language === "arabic"
        ? "اختر موقعك على الخريطة"
        : "Choose your location on the map";
    }
    if (previousPath == "/checkout/confirmation")
      return language === "arabic" ? "حفظ" : "Save";
    return language === "arabic" ? "التالي" : "Next";
  };
  handleAddressForUnknownLocation = (value) => {
    if (this.props.settings.enable_unknown_gift_recipient_location) {
      this.props.setGiftUnknownLocation(value);
    }
  };

  render() {
    const {
      settings,
      branch,
      address,
      areas,
      themeColor,
      branch_delivery_charges,
    } = this.props;
    if (
      !this.props.settings.enable_delivery &&
      !this.props.settings.enable_pickup
    )
      return <Redirect to="/" />;
    if (
      this.props.cart.delivered_items <= 0 &&
      this.props.cart.charged_items <= 0
    )
      return <Redirect to="/checkout/confirmation" />;
    if (this.props.history.action == "POP" && !this.props.customerContact)
      return <Redirect to="/checkout/details" />;

    if (!this.props.address) return <Redirect to="/" />;

    if (
      (this.props.address.selectedDeliveryType === 1 || branch.isPickup) &&
      this.props.address.pickupArea
    )
      return <Redirect to="/select/branch" />;
    if (
      settings.enable_pickup &&
      (!settings.enable_delivery || this.props.cart.pickup_only_items)
    )
      return <Redirect to="/select/branch" />;

    const language = this.props.language;
    let previousPath;
    if (this.props.history.location.state)
      previousPath = this.props.history.location.state.prevPath;

    if (
      (this.state.block && this.state.block.trim() && this.state.blockError) ||
      (this.state.street &&
        this.state.street.trim() &&
        this.state.streetError) ||
      (this.state.building &&
        this.state.building.trim() &&
        this.state.buildingError) ||
      (this.state.apartment &&
        this.state.apartment.trim() &&
        this.state.apartmentError &&
        this.state.floor?.trim() &&
        this.state.floorError)
    ) {
      let error = {};
      if (this.state.block && this.state.block.trim()) error.blockError = false;
      if (this.state.street && this.state.street.trim())
        error.streetError = false;
      if (this.state.building && this.state.building.trim())
        error.buildingError = false;
      if (this.state.apartment && this.state.apartment.trim())
        error.apartmentError = false;
      if (this.state.floor && this.state.floor.trim()) error.floorError = false;
      this.setState(error);
    }

    let selectedArea;
    if (settings.is_branch_based_ordering) {
      selectedArea = branch_delivery_charges.find(
        (bdc) => bdc.area_id === address?.area
      );
      if (selectedArea) {
        selectedArea = {
          name: selectedArea.area,
          province_name: selectedArea.province_en,
        };
      }
    } else {
      selectedArea = areas.find((a) => a.id === address?.area);
    }

    const alHamraSituationTing =
      selectedArea &&
      ([
        "arraya tower",
        "arraya center",
        "nbk tower",
        "assima mall",
        "mazaya tower",
        "international hospital",
      ].some((a) => selectedArea.name.toLowerCase().includes(a)) ||
        selectedArea.province_name === "Offices") &&
      address.selectedDeliveryType === 0;

    if (
      selectedArea?.province_name === "Mosques" &&
      address?.selectedDeliveryType === 0
    ) {
      return <Redirect to="/checkout/confirmation" />;
    }

    let selectedCountry = this.props.countries
      ? this.props.countries.find(
          (country) => country.id === this.props.address?.country
        )
      : null;
    const international = selectedCountry?.name === "International";
    const useAddressLines =
      international || selectedArea.province_name === "Kashtat";
    return (
      <div
        className="w-100 mx-0"
        style={{
          minHeight: 650,
          backgroundColor: "white",
        }}
      >
        <ProductHeader />

        <div
          className="border-top w-100"
          style={{
            marginTop: 55,
            backgroundColor: "#F5F5F5",
            minHeight: "100vh",
          }}
        >
          <div className="free-space-20-white"></div>

          <ServiceType
            setServiceType={() => {}}
            selectedServiceType={0}
            pickupOnly={
              this.props.history.location?.state?.pickupOnly ||
              this.props.cartHasPickupOnly
            }
            deliveryOnly={
              this.props.history.location?.state?.deliveryOnly ||
              this.props.cartHasDeliveryOnly
            }
          />

          {this.props.settings.enable_gifts &&
            this.props.settings.enable_gifts_staff && (
              <>
                <Gift
                  SetGift={(gift_value) => this.props.enableIsGift(gift_value)}
                  SetGiftMsg={(
                    name,
                    msg,
                    number,
                    link,
                    anonymous,
                    call_recipient,
                    gift_wrapping
                  ) =>
                    this.props.setGiftDetails(
                      name,
                      msg,
                      number,
                      link,
                      anonymous,
                      call_recipient,
                      gift_wrapping
                    )
                  }
                  name={this.props.promise.gift_name}
                  message={this.props.promise.gift_message}
                  gift_recipient_number={
                    this.props.promise.gift_recipient_number
                  }
                  gift_link={this.props.promise.gift_link}
                  gift_wrapping={this.props.promise.gift_wrapping}
                  send_gift_anonymously={
                    this.props.promise.send_gift_anonymously
                  }
                  call_recipient={this.props.promise.call_recipient}
                  unknown_location={this.props.promise.unknown_location}
                  giftDrawer={this.state.giftDrawer}
                  closeGiftDrawer={(value) =>
                    this.setState({ giftDrawer: value })
                  }
                  urlPathname={this.props.location.pathname}
                  resetAddressForUnknownLocation={() => {
                    this.setState({
                      block: "",
                      street: "",
                      building: "",
                    });
                  }}
                  errorName={this.state.errorName}
                  errorNumber={this.state.errorNumber}
                  handleErrorChange={(type, value) => {
                    if (type === "name") {
                      this.setState({ errorName: value });
                    }
                    if (type === "number") {
                      this.setState({ errorNumber: value });
                    }
                  }}
                />
                {this.props.promise.isGift &&
                  this.props.settings
                    .enable_unknown_gift_recipient_location && (
                    <div>
                      <p
                        className="box-title"
                        style={{
                          textAlign: language === "arabic" ? "right" : "left",
                          marginTop: 23,
                        }}
                      >
                        {language === "english"
                          ? "Do you know the address details? "
                          : "هل تعرف تفاصيل العنوان؟"}
                      </p>
                      <div
                        className="bordered w-100 mx-0"
                        style={{
                          backgroundColor: "white",
                          minHeight: 73,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Button
                          style={{
                            backgroundColor: this.props.promise.unknown_location
                              ? "#ffffff"
                              : themeColor,
                            color: this.props.promise.unknown_location
                              ? themeColor
                              : "white",
                            border: this.props.promise.unknown_location
                              ? `1px solid ${themeColor}`
                              : "1px solid #ffffff",
                            borderRadius: "3px",
                            width: "144px",
                            height: "42px",
                            marginRight: 15,
                            marginLeft: 15,
                          }}
                          onClick={() => {
                            this.handleAddressForUnknownLocation(false);
                            if (this.props.promise.unknown_location) {
                              this.setState({
                                block: "",
                                street: "",
                                building: "",
                              });
                            }
                          }}
                        >
                          <span
                            style={{
                              fontWeight: "bold",
                              textTransform: "none",
                            }}
                          >
                            {language === "english" ? "Yes" : "نعم"}
                          </span>
                        </Button>
                        <Button
                          style={{
                            backgroundColor: this.props.promise.unknown_location
                              ? themeColor
                              : "#ffffff",
                            color: this.props.promise.unknown_location
                              ? "white"
                              : themeColor,
                            border: this.props.promise.unknown_location
                              ? "1px solid #ffffff"
                              : `1px solid ${themeColor}`,
                            borderRadius: "3px",
                            width: "144px",
                            height: "42px",
                            marginLeft: 15,
                            marginRight: 15,
                          }}
                          onClick={() => {
                            this.handleAddressForUnknownLocation(true);
                            if (
                              this.state.block === "" ||
                              this.state.street === "" ||
                              this.state.building === ""
                            ) {
                              this.setState({
                                block: "-",
                                street: "-",
                                building: "-",
                              });
                            }
                            this.setState({
                              paci: null,
                              avenue: null,
                              apartment: null,
                              floor: null,
                              additional: null,
                            });
                          }}
                        >
                          <span
                            style={{
                              fontWeight: "bold",
                              textTransform: "none",
                            }}
                          >
                            {language === "english" ? "No" : "لا"}
                          </span>
                        </Button>
                      </div>
                    </div>
                  )}
              </>
            )}

          <DeliveryAreaLocation />
          {this.props.settings.enable_gifts &&
          this.props.settings.enable_gifts_staff &&
          this.props.promise.isGift &&
          this.props.settings.enable_unknown_gift_recipient_location &&
          this.props.promise.unknown_location ? (
            <div className="">
              <p
                className="box-title"
                style={{
                  textAlign: language === "arabic" ? "right" : "left",
                  marginTop: 23,
                }}
              >
                {language === "english"
                  ? "Receiver Information"
                  : "معلومات المستلم"}
              </p>
              <div
                className="bordered w-100 mx-0"
                style={{
                  backgroundColor: "white",
                  minHeight: 73,
                }}
                dir={language === "english" ? "ltr" : "rtl"}
              >
                <div
                  style={{
                    display: "flex",
                    marginTop: 16,
                    marginLeft: language === "english" ? 15 : 0,
                    marginRight: language === "english" ? 0 : 15,
                    alignItems: "center",
                  }}
                >
                  <CardGiftcardOutlinedIcon style={{ color: "#5b5b5b" }} />
                  <span
                    style={{
                      color: themeColor,
                      fontWeight: "bold",
                      fontSize: 14,
                      marginLeft: language === "english" ? 15 : 0,
                      marginRight: language === "english" ? 0 : 15,
                    }}
                  >
                    {language === "english"
                      ? "We will ask the receiver for their details"
                      : "سنطلب من المستلم تقديم تفاصيله"}
                  </span>
                </div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "50px auto 100px",
                    marginBottom: 26,
                    marginTop: 30,
                    alignItems: "center",
                  }}
                >
                  <div></div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      width: 200,
                      marginLeft: 3,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span
                        style={{
                          fontWeight: "bold",
                        }}
                      >
                        {language === "english" ? "Name: " : " :الاسم"}
                      </span>
                      <span>{this.props.promise.gift_name}</span>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span
                        style={{
                          fontWeight: "bold",
                        }}
                      >
                        {language === "english" ? "Phone: " : " :الهاتف"}{" "}
                      </span>
                      <span>{this.props.promise.gift_recipient_number}</span>
                    </div>
                  </div>
                  {/* <div
                    className={"bold ".concat(
                      language === "arabic" ? "text-left" : "text-right"
                    )}
                    style={{
                      color: "#5b5b5b",
                      cursor: "pointer",
                      marginRight: language === "english" ? 18 : 0,
                      marginLeft: language === "english" ? 0 : 18,
                    }}
                    onClick={() => {
                      this.setState({
                        giftDrawer: true,
                      });
                    }}
                  >
                    <span style={{ marginRight: 1, fontSize: "0.9rem" }}>
                      {language === "arabic" ? "تغيير" : "Change"}
                    </span>
                    <NavigateNextIcon
                      style={{
                        transform: language === "arabic" && "rotate(180deg)",
                      }}
                    />
                  </div> */}
                </div>
              </div>
            </div>
          ) : (
            <AddressFormNew
              selectedAddressType={this.state.selectedAddressType}
              onChangeAddressType={(val) =>
                this.setState({ selectedAddressType: val })
              }
              handleImageUpload={this.handleImageUpload}
              home_picture={this.state.home_picture}
              blockError={this.state.blockError}
              streetError={this.state.streetError}
              buildingError={this.state.buildingError}
              additionalError={this.state.additionalError}
              apartmentError={this.state.apartmentError}
              floorError={this.state.floorError}
              handleChange={this.handleChange}
              block={this.state.block}
              street={this.state.street}
              paci={this.state.paci}
              building={this.state.building}
              avenue={this.state.avenue}
              apartment={this.state.apartment}
              floor={this.state.floor}
              additional={this.state.additional}
            />
          )}
          <div style={{ height: 100 }}></div>
        </div>

        <ActionButton
          action={this.renderActionButtonText(useAddressLines)}
          color="#0099cc"
          onClick={this.handleNext}
          errorName={this.state.errorName}
          errorNumber={this.state.errorNumber}
          disabled={
            (this.props.settings.force_geolocation &&
              !international &&
              !this.props.address.gpsConfirmed &&
              !alHamraSituationTing) ||
            (this.props.promise.isGift &&
              (this.state.errorName || this.state.errorNumber))
          }
          addressPage
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    countries: state.store.store.all_countries || state.store.store.countries,
    customerContact: state.customers.customerContact,
    areas: state.store.store.areas,
    address: state.customers.address,
    settings: state.store.store.settings,
    cart: state.cart,
    branch: state.branch,
    branches: state.store.store.branches,
    auth: state.auth,
    promise: state.promise,
    cartHasPickupOnly: state.cart.pickup_only_items > 0,
    cartHasDeliveryOnly: state.cart.delivery_only_items > 0,
    themeColor: state.store.store.settings.dark || "#0099cc",
    branch_delivery_charges: state.store.store.branch_delivery_charges,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    saveAddress: (address) => dispatch(saveAddress(address)),
    enableIsGift: (value) =>
      dispatch({ type: "ENABLE_IS_GIFT", payload: value }),
    setGiftDetails: (
      name,
      message,
      number,
      link,
      anonymous,
      call_recipient,
      gift_wrapping
    ) =>
      dispatch({
        type: "SET_GIFT_DETAILS",
        payload: {
          name,
          message,
          number,
          link,
          anonymous,
          call_recipient,
          gift_wrapping,
        },
      }),
    setGiftUnknownLocation: (value) =>
      dispatch({
        type: "SET_UNKNOWN_LOCATION",
        payload: value,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(index);
